import { memo } from "react";
import { Draggable } from "react-beautiful-dnd";

import { TableRow } from "@mui/material";

import { LineDragInsertCopy } from "components/formFields/line/LineDragInsertCopy";
import { EditLineButton } from "components/utility/EditLineButton";

import { copyDown } from "services/utility/lineItems";

import { LineItem } from "views/Rentals/Rental/LineItem";

// Memoized row component to prevent unnecessary re-renders
const MemoizedLineItem = memo(
  ({
    line,
    index,
    record,
    relatedRecords,
    lineHandler,
    expandItemGroup,
    items,
    itemsCount,
    addItem,
    classes,
    classesCount,
    jobWorkcenters,
    lineItemsErrors,
    toBins,
    insertEmptyLine,
    objectType,
    isLastLine,
    lineReadOnly = false,
    nextLineReadOnly,
    setLineEdit,
    handleDeleteLine,
  }) => {
    return (
      <Draggable key={index} draggableId={`${index}`} index={index}>
        {(draggableProvided, snapshot) => {
          return (
            <TableRow
              ref={draggableProvided.innerRef}
              {...draggableProvided.draggableProps}
              sx={{
                ...draggableProvided.draggableProps.style,
                position: "inherit",
                backgroundColor: snapshot.isDragging
                  ? "dragBackground"
                  : "none",
              }}
              data-testing={"line-" + index}
            >
              <LineDragInsertCopy
                draggableProvided={draggableProvided}
                snapshot={snapshot}
                insertEmptyLine={insertEmptyLine}
                lineNumber={line.lineNumber}
                onCopyDown={() => copyDown(line, lineHandler, objectType)}
                showCopyDown={!isLastLine}
                toggleLineEdit={setLineEdit}
                lineIndex={index}
                nextLineReadOnly={nextLineReadOnly}
              />
              <EditLineButton
                onClick={setLineEdit}
                lineIndex={index}
                recordId={record.id}
                lineReadOnly={lineReadOnly}
              />

              <LineItem
                record={record}
                lineNumber={line.lineNumber}
                relatedRecords={relatedRecords}
                toBins={toBins}
                line={line}
                lineHandler={lineHandler}
                expandItemGroup={expandItemGroup}
                items={items}
                itemsCount={itemsCount}
                addItem={addItem}
                classes={classes}
                classesCount={classesCount}
                jobWorkcenters={jobWorkcenters}
                lineItemsErrors={lineItemsErrors}
                draggableProvided={draggableProvided}
                draggableSnapshot={snapshot}
                lineReadOnly={lineReadOnly}
                handleDeleteLine={handleDeleteLine}
              />
            </TableRow>
          );
        }}
      </Draggable>
    );
  },
  (prevProps, nextProps) => {
    // Custom comparison to prevent unnecessary re-renders
    return (
      prevProps.line === nextProps.line &&
      prevProps.index === nextProps.index &&
      prevProps.lineItemsErrors === nextProps.lineItemsErrors &&
      prevProps.isLastLine === nextProps.isLastLine &&
      prevProps.items === nextProps.items &&
      prevProps.classes === nextProps.classes &&
      prevProps.jobWorkcenters === nextProps.jobWorkcenters &&
      prevProps.relatedRecords === nextProps.relatedRecords &&
      prevProps.toBins === nextProps.toBins &&
      prevProps.lineReadOnly === nextProps.lineReadOnly &&
      prevProps.readOnlyLineIds === nextProps.readOnlyLineIds &&
      prevProps.nextLineReadOnly === nextProps.nextLineReadOnly
    );
  }
);

// helps React DevTools and error messages show a readable name
MemoizedLineItem.displayName = "MemoizedLineItem";

export { MemoizedLineItem };
